import { render, staticRenderFns } from "./CoThumbnail.vue?vue&type=template&id=19b5b42f&scoped=true&"
import script from "./CoThumbnail.vue?vue&type=script&lang=ts&"
export * from "./CoThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./CoThumbnail.vue?vue&type=style&index=0&id=19b5b42f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b5b42f",
  null
  
)

export default component.exports